
import React, { createContext } from "react";
import { DialogStateContextType, DialogStateProviderProps } from "./DialogStateTypes";
import { useDialogStateManager } from "./DialogStateManager";

// Export the context so it can be imported by DialogStateHooks.ts
export const DialogStateContext = createContext<DialogStateContextType | undefined>(undefined);

/**
 * Provider component that manages dialog state and makes it available to children
 * via React context
 */
export const DialogStateProvider: React.FC<DialogStateProviderProps> = ({
  open,
  onOpenChange,
  isSubmitting,
  forceKeepOpen,
  installationPhase = false,
  children,
}) => {
  // Use the manager hook to handle all state logic
  const dialogState = useDialogStateManager({
    open,
    onOpenChange,
    isSubmitting,
    forceKeepOpen,
    installationPhase,
  });

  return (
    <DialogStateContext.Provider value={dialogState}>
      {children}
    </DialogStateContext.Provider>
  );
};

// Export the default hook to use this context
export { useDialogState } from './DialogStateHooks';
